/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Create_ButtonInputs */

const en_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const fr_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer`)
};

const de_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

const it_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creare`)
};

const ru_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создавать`)
};

const es_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

const zh_cn2_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创造`)
};

const ja_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成する`)
};

const hi_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाएं`)
};

const pt_pt2_markers_create_button = /** @type {(inputs: Markers_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Markers_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_create_button = /** @type {((inputs?: Markers_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_create_button(inputs)
	if (locale === "de") return de_markers_create_button(inputs)
	if (locale === "it") return it_markers_create_button(inputs)
	if (locale === "ru") return ru_markers_create_button(inputs)
	if (locale === "es") return es_markers_create_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_create_button(inputs)
	if (locale === "ja") return ja_markers_create_button(inputs)
	if (locale === "hi") return hi_markers_create_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_create_button(inputs)
	return en_markers_create_button(inputs)
});